<div class="host-social-modal modal-v2">
  <div class="social-header">
    <h2>Scootaverse Settings</h2>

    <button title="close modal" (click)="closeDetail()">
      <mat-icon class="close-icon" aria-hidden="true" data-mat-icon-type="font">close</mat-icon>
    </button>
  </div>

  <mat-dialog-content>
    @if (showLoader) {
      <div class="loading-container"><app-loading></app-loading></div>
    }
    @if (isReadOnly) {
      <div class="basic-section general-section">
        <p class="social-link-label">Simply paste the link to your calendar event or share directly with others.</p>
        <div class="flex justify-center">
          <mat-form-field hideRequiredMarker="true" class="">
            <input
              title="socialURI"
              matInput
              disabled
              [ngModel]="data.social.socialURI"
              class="copy-link-input copy-link-readonly"
            />
          </mat-form-field>
          <button (click)="copyLink()" class="copy-link general-button">copy link</button>
        </div>
      </div>
    }

    <!-- ROOM SETTINGS -->
    @if (!isReadOnly) {
      <div class="customize-section">
        <div class="details-area">
          <form [formGroup]="socialFormGroup">
            <div class="form-container">
              <mat-form-field>
                <mat-label>Room Name</mat-label>
                <input matInput title="Room Name" formControlName="name" data-testid="room-name-input" />
                <mat-error>Social name is required.</mat-error>
              </mat-form-field>
            </div>
            <div class="form-container">
              <mat-form-field>
                <mat-label>Music Playlist</mat-label>
                <mat-select
                  id="cbo-room-music"
                  data-testid="room-music-select"
                  formControlName="playlistId"
                  panelClass="playlist-select-panel"
                  title="Music Playlist"
                >
                  <mat-select-trigger>{{ playlistSelectedName }}</mat-select-trigger>
                  @for (option of playlistOptions; track option) {
                    <mat-option
                      [id]="'playlist-' + option.playlistId"
                      [attr.data-testid]="'playlist-' + option.playlistId + '-option'"
                      [value]="option.playlistId"
                      [disabled]="option.type === 1 && !option.available"
                    >
                      @if (option.type === 1 && option.available) {
                        <mat-icon class="premium" matTooltip="Premium Playlist" svgIcon="playlist_premium"></mat-icon>
                      }
                      @if (option.type === 1 && !option.available) {
                        <mat-icon
                          class="premium-locked"
                          matTooltip="This is a Premium playlist. Contact support@scoot.app to access this."
                          >lock</mat-icon
                        >
                      }
                      @if (!option.type) {
                        <mat-icon class="non-premium" matTooltip="Standard Playlist">album</mat-icon>
                      }
                      {{ option.name }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
            <div class="form-container">
              <mat-form-field>
                <mat-label>Join Settings</mat-label>
                <mat-select
                  id="cbo-join-settings"
                  data-testid="join-setting-select"
                  formControlName="socialPermissionType"
                  title="Join Settings"
                  [panelWidth]="null"
                >
                  <mat-option id="PUBLIC" [value]="socialPermissionTypeEnum.PUBLIC">
                    Only users with link can join
                    <img
                      alt="info icon"
                      class="info-icon"
                      src="../../../../assets/images/help-icon.svg"
                      [matTooltip]="'Easiest way to have users join. Anyone who has the link can join.'"
                    />
                  </mat-option>
                  <mat-option id="COMPANY" [value]="socialPermissionTypeEnum.COMPANY">
                    Only users in my Organization can join
                    <img
                      alt="info icon"
                      class="info-icon"
                      src="../../../../assets/images/help-icon.svg"
                      [matTooltip]="'Secure your social. Users must belong to your organization before joining.'"
                    />
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            @if (socialFormGroup.get('socialPermissionType')?.value !== socialPermissionTypeEnum.PUBLIC) {
              <span class="private-join-warning">
                *This join setting will enforce participants to create a Scoot account in order to verify their
                association to you and/ or your company
              </span>
            }
            <div class="form-container">
              <mat-slide-toggle
                [attr.data-testid]="'allow-join-before-host-toggle'"
                color="primary"
                formControlName="anyoneCanStart"
                class="custom-toggle"
                hideIcon="true"
              >
                Allow join before host
              </mat-slide-toggle>
              <mat-slide-toggle
                [attr.data-testid]="'allow-join-before-host-toggle'"
                color="primary"
                formControlName="recordMeeting"
                class="custom-toggle"
                hideIcon="true"
                matTooltip="When turned on, this setting records everything in the meeting, both in the room and presentations."
              >
                Record Meeting
              </mat-slide-toggle>
            </div>
          </form>
          @if (!isReadOnly) {
            <button
              data-testid="advanced-settings-button"
              mat-button
              class="save-changes-button primary-button"
              (click)="navigateToAdvancedSettings()"
            >
              Advanced Settings
            </button>
          }
        </div>
        <app-social-theme-carousel [social]="data.social" (slideChanged)="onSlide($event)"></app-social-theme-carousel>
      </div>
    }
  </mat-dialog-content>

  <div class="footer-buttons">
    @if (!isReadOnly) {
      <button
        id="btnSaveToYourRooms"
        data-testid="save-to-your-rooms-button"
        mat-button
        matTooltip="You can only save {{ maxRoomsLimit }} {{
          maxRoomsLimit | i18nPlural: { '=1': 'room', other: 'rooms' }
        }}"
        [matTooltipDisabled]="!savedRoomsLimitReached"
        (click)="saveAsRecurring()"
        [disabled]="socialFormGroup.invalid || savedRoomsLimitReached"
        class="white-button"
      >
        Save to Your Rooms
      </button>
    }
    @if (!isReadOnly) {
      <button
        id="startSocialButton"
        data-testid="start-social-button"
        mat-button
        (click)="updateSocial(ModalCloseActionType.START)"
        [disabled]="socialFormGroup.invalid"
        class="primary-button"
      >
        Enter Scootaverse
      </button>
    }
    @if (isReadOnly) {
      <button mat-button (click)="closeDetail()" [disabled]="socialFormGroup.invalid" class="sm-button">Close</button>
    }
  </div>
</div>
